export default "__VITE_ASSET__CD9JpeIH__"